module.exports = __webpack_public_path__ + "media/public/images/logo-white-4da7d71aa65005422fad40a309f5164c.svg";